import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-plus.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const PlusCircleIcon = createSvgIcon(<Icon />, 'PlusIcon');
